import { IoOptionsOutline } from "react-icons/io5";
import ModalConfirm from "../../components/modal/modalConfirm";
import { useState } from "react";
import { planTrainingDelete, planTrainingEditStatus } from "../../config/apiSPA";
import { useNavigate } from "react-router-dom";
import ModalInfo from "../../components/modal/modalInfo";
import ModalEditDate2 from "../../components/modal/modalEditDate2";
function DetailToolMenu({ exportHandleClick, isEditable, isStatusEdited, id, onChange = () => {} }) {
  const navigate = useNavigate();
  const [modalDeletePlan, setModalDeletaPlan] = useState({ show: false, id: null });
  const [modalReschedule, setModalReschedule] = useState({ show: false, id: null });
  const [modalCancel, setModalCancel] = useState({ show: false, id: null });
  const [modalInfo, setModalInfo] = useState({ show: false, title: "Warning", text: "no text" });
  const handleClickDelete = async (val) => {
    try {
      setModalDeletaPlan((a) => ({ ...a, show: false }));
      const res = await planTrainingDelete(val);
      navigate("/training/plan/data");
    } catch (error) {
      setModalInfo({ show: true, title: "Failed", text: `Error message: ${error.message}` });
    }
  };
  const handleClickSubmitReschedule = async (val) => {
    try {
      setModalReschedule((a) => ({ ...a, show: false }));
      const payload = {
        id: val.id,
        val: "RESCHEDULE",
        rescheduleDate: val.val,
      };
      const res = await planTrainingEditStatus(payload);
      onChange();
    } catch (error) {
      setModalInfo({ show: true, title: "Failed", text: `Error message: ${error.message}` });
    }
  };
  const handleClickCancelPlan = async (id) => {
    try {
      setModalCancel((a) => ({ ...a, show: false }));
      const payload = {
        id: id,
        val: "CANCEL",
      };
      const res = await planTrainingEditStatus(payload);
      onChange();
    } catch (error) {
      setModalInfo({ show: true, title: "Failed", text: `Error message: ${error.message}` });
    }
  };
  return (
    <>
      <div className="mb-md-4 mb-3 d-md-flex">
        <div className="ms-sm-0 mt-sm-0 mt-2">
          <div className="mt-md-0 mt-2 dropdown-toggle">
            <a href="#/" data-bs-toggle="dropdown" className="text-inverse text-opacity-75 text-decoration-none">
              <i className="fa fa-download fa-fw me-1 text-theme"></i>
              Generate
            </a>
            <div className="dropdown-menu">
              <a onClick={() => exportHandleClick("taf")} className="dropdown-item" href="#/">
                Training Application Form (TAF)
              </a>
            </div>
          </div>
        </div>
        <div className="ms-sm-4 mt-sm-0 mt-2">
          <div className="mt-md-0 mt-2 dropdown-toggle">
            <a href="#/" data-bs-toggle="dropdown" className="text-inverse text-opacity-75 text-decoration-none">
              <IoOptionsOutline className="fa-fw me-1 text-theme" />
              Options
            </a>
            <div className="dropdown-menu">
              <a
                onClick={() => {
                  setModalReschedule({ show: true, id });
                }}
                className={`dropdown-item ${isEditable === 0 && isStatusEdited === 0 ? "" : "disabled"}`}
                href="#/"
              >
                Reschedule
              </a>
              <a
                onClick={() => {
                  setModalCancel({ show: true, id });
                }}
                className={`dropdown-item ${isEditable === 0 && isStatusEdited === 0 ? "" : "disabled"}`}
                href="#/"
              >
                Cancel
              </a>
              <a
                onClick={() => {
                  setModalDeletaPlan({ show: true, id });
                }}
                className={`dropdown-item ${!isEditable ? "disabled" : ""}`}
                href="#/"
              >
                Delete
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* ===== Modal Confirm Reschedule Plan  */}
      <ModalEditDate2
        show={modalReschedule.show}
        onHide={() => setModalReschedule((a) => ({ ...a, show: false }))}
        submitClick={handleClickSubmitReschedule}
        id={id}
        options={{ title: "Reschedule date", text: "Please enter reschedule date" }}
      />
      {/* ===== Modal Confirm Reschedule Plan  */}
      {/* =====  */}
      {/* ===== Modal Cancle Plan  */}
      <ModalConfirm
        show={modalCancel.show}
        onHide={() => setModalCancel((a) => ({ ...a, show: false }))}
        clicked={handleClickCancelPlan}
        id={modalCancel.id}
        title={"Warning"}
        text={"Are you sure want to cancel this plan ??"}
        theme={"danger"}
      />
      {/* ===== Modal Cancle Plan  */}
      {/* =====  */}
      {/* ===== Modal Confirm Delete Plan  */}
      <ModalConfirm
        show={modalDeletePlan.show}
        onHide={() => setModalDeletaPlan((a) => ({ ...a, show: false }))}
        clicked={handleClickDelete}
        id={modalDeletePlan.id}
        title={"Warning"}
        text={"Are you sure want to delete this plan ?"}
        theme={"danger"}
      />
      {/* ===== Modal Confirm Delete Plan  */}
      {/* =====  */}
      {/* ===== Modal Info  */}
      <ModalInfo show={modalInfo.show} title={modalInfo.title} text={modalInfo.text} theme={"danger"} clicked={() => setModalInfo((a) => ({ ...a, show: false }))} />
      {/* ===== Modal Info  */}
      {/* =====  */}
    </>
  );
}

export default DetailToolMenu;
